/**
 * What's New — release notes for the in-app banner + drawer.
 *
 * • Newest entry first.
 * • Bump CURRENT_VERSION whenever you add an entry you want to re-surface
 *   to users who already dismissed the previous banner.
 * • `tag` is optional ("New", "Improved", "Fix", etc.) — color-coded in the UI.
 */

export const CURRENT_VERSION = '2026-06-09';

export const RELEASE_NOTES = [
  {
    date: '2026-06-09',
    title: 'DASH just got better',
    summary:
      "We've been listening to your feedback and made DASH faster, smarter, and easier to use.",
    items: [
      {
        tag: 'New',
        text: 'Voice input. Tap the new microphone icon to ask your question out loud instead of typing.',
      },
      {
        tag: 'New',
        text: 'Application buttons. Pick your product (Perform, eScription One, InQuiry, and more) with one tap to get a faster, more targeted answer.',
      },
      {
        tag: 'New',
        text: 'Fast escalation to a human. Need a person? DASH now provides instructions for reaching our STAT team with live agents during after hours and weekends.',
      },
      {
        tag: 'New',
        text: 'Reset conversation button. Switching topics or asking about a different application? Reset in one click for a clean start — no more mixing context across products.',
      },
      {
        tag: 'New',
        text: "Expandable chat window. Resize the chat for a roomier view when you're working through longer answers.",
      },
      {
        tag: 'Improved',
        text: 'Faster responses. Answers come back noticeably quicker across all products.',
      },
      {
        tag: 'Improved',
        text: 'Smarter on complex questions. DASH now handles multi-part and nuanced questions with more accurate, complete answers.',
      },
      {
        tag: 'Improved',
        text: "Expanded knowledge base. We've added and refreshed internal product knowledge, so DASH answers more questions correctly the first time.",
      },
      {
        tag: 'New',
        text: 'Conversation memory. Say "again" or "what about for InQuiry" and DASH stays on context.',
      },
      {
        tag: 'Improved',
        text: 'Right product, every time. Answers are matched to the correct product family (Perform stays separate from eScription One — no cross-app confusion).',
      },
      {
        tag: 'Improved',
        text: 'Better terminology. Product-specific language like "Client > Users" and "Copied to new user" instead of legacy terms.',
      },
      {
        tag: 'New',
        text: '"Was this resolved?" Thumbs up/down on every answer so you can tell us what worked.',
      },
      {
        tag: 'Fix',
        text: 'Citations now match the product the answer is about, and URLs are always clickable.',
      },
    ],
  },
];
